<template>
  <div id="data-list-list-view" class="logistics-manage padTop32">
    <div class="filterWrap">
      <gc-cmp-vs-input
        v-model="filterText"
        class="filterInput"
        @input="getTableData(1)"
        placeholder="请输入运费模板名称"
      />
      <vs-button v-if="filtering('freight:add')" @click="addData(true)">新增</vs-button>
    </div>
    <vs-table :data="tableData" noDataText="暂无数据">
      <template slot="thead">
        <vs-th
          v-for="(column, index) in columns"
          :key="index"
          :style="column.width ? { width: column.width } : ''"
        >
          {{ column.name }}
        </vs-th>
      </template>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <template v-for="(column, indextd) in columns">
              <vs-td
                v-if="indextd !== columns.length - 1"
                :key="indextd"
                :style="column.width ? { width: column.width } : ''"
              >
                <template v-if="!indextd">{{ indextr + 1 }}</template>
                <template v-else>{{ tr[column.key] }}</template>
              </vs-td>
            </template>
            <vs-td>
              <feather-icon v-if="filtering('freight:update')"
                icon="EditIcon"
                svgClasses="w-5 h-5 stroke-current"
                class="text-primary"
                @click.stop="addData(false, tr)"
              />
              <feather-icon v-if="filtering('freight:delete')"
                icon="TrashIcon"
                svgClasses="w-5 h-5 stroke-current"
                class="ml-2 text-primary"
                @click.stop="handleDeleteData(tr)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <gc-vs-pagination
      :pager="pager"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      ></gc-vs-pagination>
  </div>
</template>

<script>
import GcCmpVsInput from "@/group-cloud/components/vsInput";
import GcCmpVsTable from "@/group-cloud/components/vsTable";
import { LogisticsApi } from "@/modules/server-api/commodity-sys/logistics";
export default {
  data() {
    return {
      filterText: "", //模糊搜索
      editPageUrl: "/modules/logistics/cost-template/edit",
      columns: [
        {
          name: "序号",
          width: "80px",
          key: "index",
        },
        {
          name: "运费模板名称",
          key: "name",
        },
        {
          name: "物流商",
          key: "expressName",
        },
        {
          name: "修改时间",
          key: "updateTime",
        },
        {
          name: "操作",
          width: "200px",
          key: "handle",
        },
      ],
      tableData: [],
      pager: {
        page: 1,
        size: 20,
        total: 20,
      }
    };
  },
  components: {
    GcCmpVsInput,
    GcCmpVsTable,
  },
  methods: {
    async getTableData(page) {
      this.$vs.loading();
      if (page) this.pager.page = page;
      this.tableData = [];
      let resp = await LogisticsApi.getCostTemplateList({
        pageNo: this.pager.page,
        pageSize: this.pager.size,
        data: { suggest: this.filterText },
      });
      // let result = [
      //   {
      //     name: "包邮",
      //     updateTime: "2020-12-12 12:12",
      //   },
      //   {
      //     name: "不包邮",
      //     updateTime: "2020-12-12 12:12",
      //   },
      // ];
      this.tableData = resp.result.list || [];
      this.pager.total = resp.result.totalCount;
      this.$vs.loading.close();
    },
    //分页
    async changePage(payload) {
      this.pager.page = payload.page || 1;
      return await this.getTableData();
    },
    //更改每页条数
    handleSizeChange(val){
      this.pager.size = val;
      this.getTableData();
    },
    handleCurrentChange(val){
      this.pager.page = val;
      this.getTableData();
    },
    //新增物流
    addData(isNew, row) {
      let title = "";
      if (isNew) {
        title = "新增";
        sessionStorage.setItem("costTmpInfo", "{}");
      } else {
        title = "编辑";
        sessionStorage.setItem("costTmpInfo", JSON.stringify(row));
      }
      sessionStorage.setItem("title", title);
      this.$router.push({ path: this.editPageUrl }).catch(() => {});
    },
    //删除物流
    handleDeleteData(row) {
      this.$vs.dialog({
        type: "confirm",
        title: `操作提示`,
        text: `您确认删除该运费模板吗？`,
        acceptText: "确认",
        cancelText: "取消",
        accept: () => {
          this.queryDeleteData(row);
        },
      });
    },
    async queryDeleteData(row) {
      let res = await LogisticsApi.deleteCostTemplateList({ id: row.id });
      if (res.succ == 1) {
        this.$notifySuccess("删除成功");
        this.getTableData();
      } else {
        this.$notifyError(res.error);
      }
    },
  },
  created() {
    this.getTableData();
  },
};
</script>

<style lang="scss" scoped>
@import "@/modules/commodity-sys/commodity.scss";
.logistics-manage {
  .vs-table thead th {
    white-space: nowrap;
  }
}
</style>
